import { render, staticRenderFns } from "./UserSecurityForm.vue?vue&type=template&id=6722b787&"
import script from "./UserSecurityForm.vue?vue&type=script&lang=ts&"
export * from "./UserSecurityForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports